import { naturezaCentroCusto, rotuloCentroCusto } from "../../../hooks/nova-obra.tipos";
import { useMemo } from "react";
import { useObraCentrosCusto, useObraTiposObra } from "@/modules/obras";
import { readTiposObra, tipoDominante } from "../../../hooks/nova-obra.tipos";
import { useNovaObra } from "../../../hooks/nova-obra.context";
import type { TipoObraItem } from "../../../hooks/nova-obra.tipos";
import type { SecaoTiposObraProps } from "./types-secao-tipos-obra";

export function useSecaoTiposObra({ onEditar }: SecaoTiposObraProps) {
  const { state } = useNovaObra();
  const centros = useObraCentrosCusto(state.obra.embarcacaoId);
  const catalogo = useObraTiposObra();
  const dados = useMemo(() => readTiposObra(state.etapas.tiposObra), [state.etapas.tiposObra]);
  const uidDominante = tipoDominante(dados)?.uid;
  const principal = centros.data.find((centro) => centro.id === dados.centroCustoPrincipalId);
  const itemDoTipo = (tipo: TipoObraItem) => {
    const vigente = catalogo.data.find((item) => item.id === tipo.tipoObraId);
    return { tipo, nome: vigente?.nome ?? tipo.nome, dominante: tipo.uid === uidDominante };
  };
  const tipos = dados.tipos.map(itemDoTipo);
  const centrosAdicionais = dados.centrosAdicionais.map((adicional) => ({
    uid: adicional.uid,
    natureza: naturezaCentroCusto(adicional.centro) === "subsea" ? "SubSea" : "Adicional",
    rotulo: rotuloCentroCusto(adicional.centro),
    tipos: adicional.tipos.map(itemDoTipo),
  }));

  return {
    centroPrincipal: principal ? rotuloCentroCusto(principal) : null,
    tipos,
    centrosAdicionais,
    onEditar,
  };
}
